import { Dispatch } from 'react';
import Actions from './Actions';

export type State = {
	bucketRange: {
		minRev: number;
		maxRev: number;
	};
	description: string;
	importDate: string;
	competitorLoading: boolean;
	keyFiguresLoading: boolean;
	marketShareLoading: boolean;
	hasTimeSeriesData: boolean;
	hasKeyFiguresData: boolean;
	hasMarketShareData: boolean;
};

export const getInitialState = (description: string): State => ({
	bucketRange: {
		minRev: 0,
		maxRev: 0
	},
	description,
	importDate: '',
	competitorLoading: true,
	keyFiguresLoading: true,
	marketShareLoading: true,
	hasTimeSeriesData: false,
	hasKeyFiguresData: false,
	hasMarketShareData: false
});

export const setBucketRange = (dispatch: Dispatch<any>) => (bucketRange: { minRev: number; maxRev: number }) => {
	dispatch({ type: Actions.SET_BUCKET_RANGE, bucketRange });
};

export const setDescription = (dispatch: Dispatch<any>, state: State) => (description: string) => {
	dispatch({ type: Actions.SET_DESCRIPTION, description });
};

export const setImportDate = (dispatch: Dispatch<any>) => (date: string) => {
	dispatch({ type: Actions.SET_IMPORT_DATE, date });
};

export const setHasTimeSeriesData = (dispatch: Dispatch<any>) => (has: boolean) => {
	dispatch({ type: Actions.SET_HAS_TIME_SERIES_DATA, has });
};

export const setHasKeyFiguresData = (dispatch: Dispatch<any>) => (has: boolean) => {
	dispatch({ type: Actions.SET_HAS_KEY_FIGURES_DATA, has });
};

export const setHasMarketShareData = (dispatch: Dispatch<any>) => (has: boolean) => {
	dispatch({ type: Actions.SET_HAS_MARKET_SHARE_DATA, has });
};

export const setCompetitorLoading = (dispatch: Dispatch<any>) => (loading: boolean) => {
	dispatch({ type: Actions.SET_COMPETITOR_LOADING, loading });
};

export const setKeyFiguresLoading = (dispatch: Dispatch<any>) => (loading: boolean) => {
	dispatch({ type: Actions.SET_KEY_FIGURES_LOADING, loading });
};

export const setMarketShareLoading = (dispatch: Dispatch<any>) => (loading: boolean) => {
	dispatch({ type: Actions.SET_MARKET_SHARE_LOADING, loading });
};
